import { MegaMenuProps } from "./types";

interface NavigationItem {
  title: string;
  link?: string;
  children?: MegaMenuProps;
  external?: boolean;
}

const templateCallout = {
  title: 'Templates',
  icon: 'fa-solid fa-box',
  image: '/images/templates/testimonial-form.png',
  caption: 'Free form, survey, and quiz templates',
  link: '/templates',
  linkText: 'View Templates'
}

export const navigation: NavigationItem[] = [
  {
    title: 'Features',
    children: {
      lists: [
        {
          title: 'Core Features',
          icon: 'fa-solid fa-box',
          items: [
            {
              title: 'AI Form Assistant',
              description: 'Create forms instantly with AI assistance',
              link: '/features/ai-form-assistant',
            },
            {
              title: 'Conversational Forms',
              description: 'Create natural flowing conversational forms',
              link: '/features/conversational-forms',
            },
            {
              title: 'Conditional Logic',
              description: 'Build dynamic forms with smart branching',
              link: '/features/conditional-logic',
            },
            {
              title: 'Calculator Forms',
              description: 'Create forms with built-in calculations',
              link: '/features/calculator-forms',
            },
            {
              title: 'Multi-Step Forms',
              description: 'Break long forms into manageable steps',
              link: '/features/multi-step-forms',
            },
          ]
        },
        {
          title: 'Advanced Tools',
          icon: 'fa-solid fa-wand-magic-sparkles',
          items: [
            {
              title: 'AI Response Analysis',
              description: 'Get AI-powered insights from responses',
              link: '/features/ai-response-analysis',
            },
            {
              title: 'AI Chat Assistant',
              description: 'Build and edit forms through AI conversation',
              link: '/features/ai-chat-assistant',
            },
            {
              title: 'Analytics & Insights',
              description: 'Track performance with detailed analytics',
              link: '/features/analytics',
            },
            {
              title: 'Custom Branding',
              description: 'Match forms to your brand identity',
              link: '/features/custom-branding',
            },
            {
              title: 'Typeform Alternative',
              description: 'See why Formsuite is the best Typeform alternative and migrate your forms in one click',
              link: '/typeform-alternative',
            },
          ]
        }
      ],
      callout: {
        title: 'All Features',
        icon: 'fa-solid fa-grid-2',
        image: '/images/ai-gen-form.png',
        caption: 'Explore everything Formsuite has to offer',
        link: '/features',
        linkText: 'View All Features →'
      },
    }
  },
  {
    title: 'Solutions',
    children: {
      lists: [
        {
          title: 'By Use Case',
          icon: 'fa-solid fa-bullseye',
          items: [
            {
              title: 'Lead Generation',
              description: 'Capture and qualify leads effortlessly',
              link: '/solutions/lead-generation',
            },
            {
              title: 'Customer Feedback',
              description: 'Gather valuable insights from customers',
              link: '/solutions/customer-feedback',
            },
            {
              title: 'Product Recommendation',
              description: 'Guide users to the right products',
              link: '/solutions/product-recommendation',
            },
            {
              title: 'Employee Onboarding',
              description: 'Streamline your onboarding process',
              link: '/solutions/employee-onboarding',
            },
            {
              title: 'Event Registration',
              description: 'Manage event signups seamlessly',
              link: '/solutions/event-registration',
            },
          ]
        },
        {
          title: 'By Industry',
          icon: 'fa-solid fa-building',
          items: [
            {
              title: 'E-commerce',
              description: 'Forms built for online stores',
              link: '/solutions/ecommerce-forms',
            },
            {
              title: 'SaaS',
              description: 'Collect feedback and generate leads',
              link: '/solutions/saas-forms',
            },
            {
              title: 'Agencies',
              description: 'Client intake and project scoping',
              link: '/solutions/agency-forms',
            },
            {
              title: 'HR Teams',
              description: 'Streamline HR workflows',
              link: '/solutions/hr-forms',
            },
          ]
        }
      ],
      callout: {
        title: 'All Solutions',
        icon: 'fa-solid fa-lightbulb',
        image: '/images/solutions-form-callout.png',
        caption: 'Find the perfect solution for your needs',
        link: '/solutions',
        linkText: 'View All Solutions →'
      },
    }
  },
  {
    title: 'Templates',
    link: '/templates',
  },
  {
    title: 'Resources',
    children: {
      lists: [
        {
          title: 'Documentation',
          icon: 'fa-solid fa-book',
          items: [
            {
              title: 'Help Center',
              description: 'Find answers to common questions',
              link: '/help',
            },
            {
              title: 'Getting Started',
              description: 'Quick start guide for new users',
              link: '/help/getting-started',
            },
            {
              title: 'How to Articles',
              description: 'Step-by-step guides and tutorials for advanced features',
              link: '/help/articles',
            },
          ]
        },
        {
          title: 'Learn',
          icon: 'fa-solid fa-graduation-cap',
          items: [
            {
              title: 'Guides & Tutorials',
              description: 'Step-by-step walkthroughs',
              link: '/help/articles',
            },
            // {
            //   title: 'Video Tutorials',
            //   description: 'Watch and learn visually',
            //   link: '/resources/videos',
            // },
            {
              title: 'Blog',
              description: 'Tips, updates, and best practices',
              link: '/help/use-cases',
            },
            {
              title: 'Typeform Alternative',
              description: 'See why Formsuite is the best Typeform alternative and migrate your forms in one click',
              link: '/typeform-alternative',
            },
          ]
        },
        {
          title: 'Support',
          icon: 'fa-solid fa-headset',
          items: [
            {
              title: 'Contact Us',
              description: `We'd love to hear from you`,
              link: '/contact',
            },
            {
              title: 'Status Page',
              description: 'Check system status and uptime',
              link: '/status',
            },
            {
              title: 'Community Forum',
              description: 'Connect with other users',
              link: 'https://formsuite.canny.io/feature-requests',
              external: true,
            },
          ]
        }
      ],
      callout: {
        title: 'Need Help?',
        icon: 'fa-solid fa-life-ring',
        image: '/images/blog-menu-callout.png',
        caption: 'Get in touch with our support team',
        link: '/contact',
        linkText: 'Contact Support →'
      },
    }
  },
  {
    title: 'Pricing',
    link: '/pricing',
  },
]